/**
 * @generated SignedSource<<3d289cf18b1ab1a03597f53ca963062d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameOption_updateVaultSettings_Mutation$variables = {
  name: string;
  vaultId: string;
};
export type RenameOption_updateVaultSettings_Mutation$data = {
  readonly updateVaultSettings: {
    readonly vault: {
      readonly id?: string;
      readonly name: string;
    };
  } | null;
};
export type RenameOption_updateVaultSettings_Mutation = {
  response: RenameOption_updateVaultSettings_Mutation$data;
  variables: RenameOption_updateVaultSettings_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "name"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "vaultId"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "name",
        "variableName": "name"
      },
      {
        "kind": "Variable",
        "name": "vaultId",
        "variableName": "vaultId"
      }
    ],
    "kind": "ObjectValue",
    "name": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "RenameOption_updateVaultSettings_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VaultsUpdateVaultSettingsMutationPayload",
        "kind": "LinkedField",
        "name": "updateVaultSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vault",
            "kind": "LinkedField",
            "name": "vault",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  (v4/*: any*/)
                ],
                "type": "Node",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "RenameOption_updateVaultSettings_Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "VaultsUpdateVaultSettingsMutationPayload",
        "kind": "LinkedField",
        "name": "updateVaultSettings",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Vault",
            "kind": "LinkedField",
            "name": "vault",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "kind": "TypeDiscriminator",
                "abstractKey": "__isNode"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "05caf2ba6c01fe9555ce23c6796d68ca",
    "id": null,
    "metadata": {},
    "name": "RenameOption_updateVaultSettings_Mutation",
    "operationKind": "mutation",
    "text": "mutation RenameOption_updateVaultSettings_Mutation(\n  $vaultId: ID!\n  $name: String!\n) {\n  updateVaultSettings(input: {vaultId: $vaultId, name: $name}) {\n    vault {\n      name\n      ... on Node {\n        __isNode: __typename\n        id\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "6ea398447ea1c38b6004148782113286";

export default node;
